export default function isUndefined(value) {
    return typeof value === 'undefined';
}
//# sourceMappingURL=is-undefined.js.map